import { H1, Inline, RouteTabItem, RouteTabs, Box } from "@adfenix/alexandria";
import Page from ".";
import { CSSProperties, ReactNode } from "react";
import { SelectHqAndOfficeSwitch } from "components/SelectHqOfficeCombobox/SelectHqAndOfficeSwitch";

interface Props {
  title: string;
  children: ReactNode;

  /**
   * If true, the HQ/office picker will be shown in the header.
   */
  hqPicker?: boolean;

  /**
   * Pass a Button if you have one action or a DropdownMenu if you have multiple.
   */
  action?: ReactNode;

  /**
   * Used to render navigation to subroutes in the header.
   * Links to completely different pages can instead be added as an action.
   */
  tabItems?: RouteTabItem[];

  /**
   * Default results in the page default which is 980px
   * Large results in 1440px.
   * Full results in no max width.
   */
  pageSize?: "default" | "large" | "full";

  style?: CSSProperties;
}

/**
 * Page wrapper with some opinionated defaults for back office pages.
 */
export const BackOfficePage = ({
  title,
  children,
  hqPicker = false,
  tabItems,
  pageSize = "default",
  action,
  style
}: Props) => {
  const fullWidth = pageSize !== "default";
  const pageStyle = pageSize === "large" ? { maxWidth: "1440px" } : {};

  return (
    <Page
      style={{ ...pageStyle, ...style }}
      header={
        <>
          <Inline
            alignItems="center"
            justifyContent="space-between"
            style={{ marginBottom: tabItems ? "" : "20px" }}
          >
            <H1>{title}</H1>

            <Inline alignItems="center" gap="m">
              {hqPicker && <SelectHqAndOfficeSwitch />}
              {action}
            </Inline>
          </Inline>
          {tabItems && (
            <Box style={{ marginBottom: "20px" }}>
              <RouteTabs items={tabItems} />
            </Box>
          )}
        </>
      }
      fullWidth={fullWidth}
    >
      {children}
    </Page>
  );
};
